import { useOutletContext, useParams } from "react-router";
import GitSettings from "../../components/template-modules/GitSettings";
import { IAppDetails } from "../../types";


const AppSettingsGit = () => {
    const { appName } = useParams();
    const { appDetails } = useOutletContext<{ appDetails: IAppDetails }>();

    return (
        <GitSettings pipelineId={appDetails.pipelineId || appName!} />
    );
}

export default AppSettingsGit;